<div class="chart-card">
  <div class="chart-header">
    <h3 class="chart-title">{{ title }}</h3>
  </div>
  <div class="chart-body">
    <div class="chart-container">
      <canvas
        baseChart
        [data]="doughnutChartData"
        [options]="doughnutChartOptions"
        [type]="'doughnut'"
      ></canvas>
    </div>
    <div class="legend">
      <div class="legend-item" *ngFor="let cat of categories">
        <span class="legend-dot" [style.background-color]="cat.color"></span>
        <span class="legend-label">{{ cat.name }}</span>
        <span class="legend-value">{{ cat.count }}</span>
      </div>
    </div>
  </div>
</div>
